
{
  "delete": "Delete"
}
